import { render } from "./scopeOfSupply.vue?vue&type=template&id=160e5d02"
import script from "./scopeOfSupply.vue?vue&type=script&lang=js"
export * from "./scopeOfSupply.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__